/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import {localeManager} from "language";

// OS Timezone Display.
export default function getTimezoneInfo() {
  const timezoneData = localeManager.getTimezoneData();

  // FIXME: Emulate the previous behaviour where the timezone (if any) is
  // wrapped in parentheses. Try to avoid doing this in the future.
  timezoneData.abbreviation = timezoneData.abbreviation ?
    `(${timezoneData.abbreviation})`
  : undefined;

  return timezoneData;
}



// WEBPACK FOOTER //
// ../datetime/getTimezoneInfo.js